import { ActionsObservable, ofType } from 'redux-observable';
import {
  AdminAppAction,
  LoadPageRequestAction,
  PageActionType,
  loadImage,
  loadPageError,
  loadPageSuccess,
} from '../../actions';
import { GET_PAGE_QUERY, GetPageData, GetPageVariables } from '../../queries';
import { Observable, of } from 'rxjs';
import { mergeAll, switchMap } from 'rxjs/operators';
import { EpicDependencies } from '../epic-dependencies';
import { PagesState } from '../../state';

export const loadPageEpic = <S extends { pages: PagesState }>(
  action$: ActionsObservable<LoadPageRequestAction>,
  state: S,
  { client }: EpicDependencies,
): Observable<any> =>
  action$.pipe(
    ofType<AdminAppAction, LoadPageRequestAction>(
      PageActionType.LoadPageRequest,
    ),
    switchMap(async (action: LoadPageRequestAction) => {
      const { data, errors } = await client.query<
        GetPageData,
        GetPageVariables
      >({
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        query: GET_PAGE_QUERY,
        variables: {
          id: action.pageKey,
        },
      });

      if (errors) {
        return of(loadPageError(action.pageKey, errors));
      } else if (data) {
        const imageActions = data.page.images.map(posterImage =>
          loadImage(posterImage.image.id, {
            id: posterImage.image.id,
            url: posterImage.image.url,
          }),
        );

        const posterImages = data.page.images.map(posterImage => ({
          imageKey: posterImage.image.id,
          type: posterImage.type,
        }));

        const tags = data.page.tags.map(tag => tag.name).join(' ');

        return of(
          loadPageSuccess(action.pageKey, {
            content: data.page.content,
            description: data.page.description,
            discourageIndexing: data.page.discourageIndexing,
            id: data.page.id,
            path: data.page.path,
            pinterestDescription: data.page.pinterestDescription || '',
            posterImages,
            publishAt: data.page.publishAt,
            tags,
            title: data.page.title,
          }),
          ...(imageActions as any),
        );
      } else {
        throw new Error('No data.');
      }
    }),
    mergeAll(),
  );
